/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface GetMedicationPrescriptionHistoryRequest {
    patientId: string;
    drugName?: string;
}

/**
 * 
 */
export class MedicationProviderApi extends runtime.BaseAPI {

    /**
     * Fetches prescription history from RXNT EHR system for a specific patient
     * Get medication prescription history from RXNT
     */
    async getMedicationPrescriptionHistoryRaw(requestParameters: GetMedicationPrescriptionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMedicationPrescriptionHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['drugName'] != null) {
            queryParameters['drugName'] = requestParameters['drugName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/medications/{patientId}/history`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Fetches prescription history from RXNT EHR system for a specific patient
     * Get medication prescription history from RXNT
     */
    async getMedicationPrescriptionHistory(requestParameters: GetMedicationPrescriptionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getMedicationPrescriptionHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
